module.exports = __webpack_public_path__ + "img/google-stadia-01.ea5d0253.webp";